import { render, staticRenderFns } from "./RELTempoTrecho.vue?vue&type=template&id=5b685249&"
import script from "./RELTempoTrecho.vue?vue&type=script&lang=js&"
export * from "./RELTempoTrecho.vue?vue&type=script&lang=js&"
import style0 from "./RELTempoTrecho.vue?vue&type=style&index=0&id=5b685249&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports